import React from "react";
import { useState } from "react";

export const RoundedButton = ({
    id,
    submitHandler,
    text,
    type,
    textColor,
    buttonColor,
    hoverColor,
    outlineColor,
    hoverTextColor,
    hoverOutlineColor,
    disabledColor,
    clickHandler,
    mouseDownHandler,
    className,
    cornerRadius,
    width,
    disabled,
    thinBordered
}) => {
    const [hover, setHover] = useState(false);

    const styles = {
        standard: {
            backgroundColor: disabled ? disabledColor : hover ? hoverColor: buttonColor,
            color: hover ? hoverTextColor : textColor,
            borderRadius: cornerRadius,
            borderColor: disabled ? disabledColor : hover ? hoverOutlineColor : outlineColor,
            borderStyle: "solid",
            width: width,
            borderWidth: thinBordered ? '1px' : ''
        }
    }

    return (
        <button style={styles.standard}
            id={id}
            className={className}
            type={type}
            onSubmit={submitHandler}
            onMouseEnter={() => {
                setHover(true);
            }}
            onMouseLeave={() => {
                setHover(false);
            }}
            onClick={clickHandler}
            onMouseDown={mouseDownHandler}
            disabled={disabled}
            >
            {text}
        </button >
    )
}

export const ButtonColor = {
    DeleteRed: 'var(--base-color-delete-red',
    Red: 'var(--base-color-red)',
    LightGrey: 'var(--base-color-light-gray)',
    DarkGrey: 'var(--base-color-dark-gray)',
    Grey: 'var(--base-color-gray)',
    Teal: 'var(--base-color-teal)',
    Green: 'var(--base-color-green)',
    DarkGreen: 'var(--base-color-dark-green)',
    DarkBlue: 'var(--base-color-dark-blue)',
    White: 'White',
    Black: 'Black'
}

export const ButtonCorner = {
    SevenPX: '7px',
    TenPX: '10px',
    FourPX: '4px',
    Straight: '0px',
}